import { Box, Typography } from '@mui/material';

const Title = ({ data }: any) => {
  const hasLabel = data.label !== '' && data.label;

  return (
    <Box
      sx={{
        padding: '16px',
        ...data?.style,
        bgcolor: data?.fullData?.bgColor || '#fff',
        textAlign: data?.fullWidth?.titleStyle?.textAlign || 'start',
        borderRadius: data?.fullData?.borderRadius || '0px',
        height: 'fit-content',
      }}
    >
      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#475467',
          ...data?.fullData?.titleStyle,
        }}
        variant="h1"
        mb={'8px'}
      >
        {hasLabel ? data.label : 'Title'}
      </Typography>
    </Box>
  );
};

export default Title;
